(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-sept-oferta"] && !Shopify.designMode) return;
  try {
    
(() => {
  const pad = value => String(Math.max(0, value)).padStart(2, '0');
  const start = root => {
    if (root.dataset.countdownReady === 'true') return;
    const cycleSeconds = Number(root.dataset.cycleHours) * 3600;
    if (!Number.isFinite(cycleSeconds) || cycleSeconds <= 0) return;
    root.dataset.countdownReady = 'true';
    const fields = {
      hours: root.querySelector('[data-hours]'),
      minutes: root.querySelector('[data-minutes]'),
      seconds: root.querySelector('[data-seconds]')
    };
    const update = () => {
      const remaining = cycleSeconds - (Math.floor(Date.now() / 1000) % cycleSeconds);
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor(remaining / 60) % 60;
      const seconds = remaining % 60;
      fields.hours.textContent = pad(hours);
      fields.minutes.textContent = pad(minutes);
      fields.seconds.textContent = pad(seconds);
    };
    update();
    window.setInterval(update, 1000);
  };
  const init = scope => scope.querySelectorAll('[data-sept-countdown]').forEach(start);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-sept-productos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var media = event.target.closest('[data-sept-product-media]');
  if (!media || !window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
  event.preventDefault();
  media.classList.toggle('is-showing-secondary');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
